import { render, staticRenderFns } from "./EventRegistrationSuccess.vue?vue&type=template&id=62ccfb62&scoped=true&"
import script from "./EventRegistrationSuccess.vue?vue&type=script&lang=js&"
export * from "./EventRegistrationSuccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62ccfb62",
  null
  
)

export default component.exports